export const FilterComboboxEnumKey = Object.freeze({
  Today: "Today",
  ThisWeek: "ThisWeek",
  ThisMonth: "ThisMonth",
  ThisYear: "ThisYear",
  Yesterday: "Yesterday",
  PreviousWeek: "PreviousWeek",
  PreviousMonth: "PreviousMonth",
  PreviousYear: "PreviousYear",
  Tomorrow: "Tomorrow",
  NextWeek: "NextWeek",
  NextMonth: "NextMonth",
  NextYear: "NextYear",
  Between: "Between",
  Empty: "Empty",
  NotEmpty: "NotEmpty",
  Equal: "=",
  NotEqual: "<>",
  Contains: "contains",
  Notcontains: "notcontains",
  Startswith: "startswith",
  Endswith: "endswith",
  Less: "<",
  LessAndEqual: "<=",
  Greater: ">",
  GreaterAndEqual: ">=",
  ChooseTime: "ChooseTime",
  AllTime: "AllTime",
  Expired: "Expired",
  UnExpired: "UnExpired",
  Personal: "Personal",
  Unit: "Unit",
});
// danh sách các loại toán tử common
export const ListOperatorCommon = {
  // danh sách toán tử dạng text
  listOperatorText: [
    {
      ID: 1,
      Text: "i18nCommon.Contain",
      Value: FilterComboboxEnumKey.Contains,
      ShowInput: true
    },
    {
      ID: 5,
      Text: "i18nCommon.NotContain",
      Value: FilterComboboxEnumKey.Notcontains,
      ShowInput: true
    },
    {
      ID: 2,
      Text: "i18nCommon.Equal",
      Value: FilterComboboxEnumKey.Equal,
      ShowInput: true
    },
    {
      ID: 3,
      Text: "i18nCommon.StartSwith",
      Value: FilterComboboxEnumKey.Startswith,
      ShowInput: true
    },
    {
      ID: 4,
      Text: "i18nCommon.EndSwith",
      Value: FilterComboboxEnumKey.Endswith,
      ShowInput: true
    },
    {
      ID: 6,
      Text: "i18nCommon.Empty",
      Value: FilterComboboxEnumKey.Empty,
      ShowInput: false
    },
    {
      ID: 7,
      Text: "i18nCommon.NotEmpty",
      Value: FilterComboboxEnumKey.NotEmpty,
      ShowInput: false
    }
  ],
  listOperatorSingleSelect: [
    {
      ID: 1,
      Text: "i18nCommon.Equal",
      Value: FilterComboboxEnumKey.Equal,
      ShowInput: true
    },
    {
      ID: 2,
      Text: "i18nCommon.Other",
      Value: FilterComboboxEnumKey.NotEqual,
      ShowInput: true
    }
  ],
  listOperatorMultipleSelect: [
    {
      ID: 1,
      Text: "i18nCommon.Equal",
      Value: FilterComboboxEnumKey.Equal,
      ShowInput: true
    },
    {
      ID: 2,
      Text: "i18nCommon.Contain",
      Value: FilterComboboxEnumKey.Contains,
      ShowInput: true
    },
    {
      ID: 3,
      Text: "i18nCommon.Other",
      Value: FilterComboboxEnumKey.NotEqual,
      ShowInput: true
    }
  ],
  listOperatorComplex: [
    {
      ID: 1,
      Text: "i18nCommon.Equal",
      Value: FilterComboboxEnumKey.Equal,
      ShowInput: true
    },
    {
      ID: 2,
      Text: "i18nCommon.Higher",
      Value: FilterComboboxEnumKey.Greater,
      ShowInput: true
    },
    {
      ID: 3,
      Text: "i18nCommon.Smaller",
      Value: FilterComboboxEnumKey.Less,
      ShowInput: true
    },
    {
      ID: 8,
      Text: "i18nCommon.Between",
      Value: FilterComboboxEnumKey.Between,
      ShowInput: true,
      BetweenDate: true
    }
  ],
  listOperatorCombobox: [
    {
      ID: 1,
      Text: "i18nCommon.Equal",
      Value: FilterComboboxEnumKey.Equal,
      ShowInput: true
    },
    {
      ID: 2,
      Text: "i18nCommon.Other",
      Value: FilterComboboxEnumKey.NotEqual,
      ShowInput: true
    },
    {
      ID: 3,
      Text: "i18nCommon.Empty",
      Value: FilterComboboxEnumKey.Empty,
      ShowInput: false
    },
    {
      ID: 4,
      Text: "i18nCommon.NotEmpty",
      Value: FilterComboboxEnumKey.NotEmpty,
      ShowInput: false
    }
  ],
  listOperatorComboboxMultiple: [
    {
      ID: 1,
      Text: "i18nCommon.Equal",
      Value: FilterComboboxEnumKey.Equal,
      ShowInput: true
    },
    {
      ID: 2,
      Text: "i18nCommon.Other",
      Value: FilterComboboxEnumKey.NotEqual,
      ShowInput: true
    },
    {
      ID: 3,
      Text: "i18nCommon.Empty",
      Value: FilterComboboxEnumKey.Empty,
      ShowInput: false
    },
    {
      ID: 4,
      Text: "i18nCommon.NotEmpty",
      Value: FilterComboboxEnumKey.NotEmpty,
      ShowInput: false
    }
  ],
  listOperatorComboboxMultiple2: [
    {
      ID: 1,
      Text: "i18nCommon.Equal",
      Value: FilterComboboxEnumKey.Equal,
      ShowInput: true
    },
    {
      ID: 2,
      Text: "i18nCommon.Other",
      Value: FilterComboboxEnumKey.NotEqual,
      ShowInput: true
    }
  ],
  listOperatorNumber: [
    {
      ID: 1,
      Text: "i18nCommon.Equal",
      Value: FilterComboboxEnumKey.Equal,
      ShowInput: true
    },
    {
      ID: 2,
      Text: "i18nCommon.Other",
      Value: FilterComboboxEnumKey.NotEqual,
      ShowInput: true
    },
    {
      ID: 3,
      Text: "i18nCommon.Smaller",
      Value: FilterComboboxEnumKey.Less,
      ShowInput: true
    },
    {
      ID: 4,
      Text: "i18nCommon.SmallerOrEqual",
      Value: FilterComboboxEnumKey.LessAndEqual,
      ShowInput: true
    },
    {
      ID: 5,
      Text: "i18nCommon.Higher",
      Value: FilterComboboxEnumKey.Greater,
      ShowInput: true
    },
    {
      ID: 6,
      Text: "i18nCommon.HigherOrEqual",
      Value: FilterComboboxEnumKey.GreaterAndEqual,
      ShowInput: true
    },
    {
      ID: 7,
      Text: "i18nCommon.Empty",
      Value: FilterComboboxEnumKey.Empty,
      ShowInput: false
    },
    {
      ID: 8,
      Text: "i18nCommon.NotEmpty",
      Value: FilterComboboxEnumKey.NotEmpty,
      ShowInput: false
    }
  ],
  listOperatorDate: [
    {
      ID: 1,
      Text: "i18nCommon.Equal",
      Value: FilterComboboxEnumKey.Equal,
      ShowInput: true
    },
    {
      ID: 2,
      Text: "i18nCommon.Other",
      Value: FilterComboboxEnumKey.NotEqual,
      ShowInput: true
    },
    {
      ID: 3,
      Text: "i18nCommon.Smaller",
      Value: FilterComboboxEnumKey.Less,
      ShowInput: true
    },
    {
      ID: 4,
      Text: "i18nCommon.SmallerOrEqual",
      Value: FilterComboboxEnumKey.LessAndEqual,
      ShowInput: true
    },
    {
      ID: 5,
      Text: "i18nCommon.Higher",
      Value: FilterComboboxEnumKey.Greater,
      ShowInput: true
    },
    {
      ID: 6,
      Text: "i18nCommon.HigherOrEqual",
      Value: FilterComboboxEnumKey.GreaterAndEqual,
      ShowInput: true
    },
    {
      ID: 7,
      Text: "i18nCommon.Empty",
      Value: FilterComboboxEnumKey.Empty,
      ShowInput: false
    },
    {
      ID: 8,
      Text: "i18nCommon.NotEmpty",
      Value: FilterComboboxEnumKey.NotEmpty,
      ShowInput: false
    },
    {
      ID: 9,
      Text: "i18nCommon.ToDay",
      Value: FilterComboboxEnumKey.Today,
      ShowInput: false
    },
    {
      ID: 10,
      Text: "i18nCommon.ThisWeek",
      Value: FilterComboboxEnumKey.ThisWeek,
      ShowInput: false
    },
    {
      ID: 11,
      Text: "i18nCommon.ThisMonth",
      Value: FilterComboboxEnumKey.ThisMonth,
      ShowInput: false
    },
    {
      ID: 12,
      Text: "i18nCommon.ThisYear",
      Value: FilterComboboxEnumKey.ThisYear,
      ShowInput: false
    },
    {
      ID: 13,
      Text: "i18nCommon.Yesterday",
      Value: FilterComboboxEnumKey.Yesterday,
      ShowInput: false
    },
    {
      ID: 14,
      Text: "i18nCommon.PreviousWeek",
      Value: FilterComboboxEnumKey.PreviousWeek,
      ShowInput: false
    },
    {
      ID: 15,
      Text: "i18nCommon.PreviousMonth",
      Value: FilterComboboxEnumKey.PreviousMonth,
      ShowInput: false
    },
    {
      ID: 16,
      Text: "i18nCommon.PreviousYear",
      Value: FilterComboboxEnumKey.PreviousYear,
      ShowInput: false
    },
    {
      ID: 17,
      Text: "i18nCommon.Tomorrow",
      Value: FilterComboboxEnumKey.Tomorrow,
      ShowInput: false
    },
    {
      ID: 18,
      Text: "i18nCommon.NextWeek",
      Value: FilterComboboxEnumKey.NextWeek,
      ShowInput: false
    },
    {
      ID: 19,
      Text: "i18nCommon.NextMonth",
      Value: FilterComboboxEnumKey.NextMonth,
      ShowInput: false
    },
    {
      ID: 20,
      Text: "i18nCommon.NextYear",
      Value: FilterComboboxEnumKey.NextYear,
      ShowInput: false
    },
    {
      ID: 21,
      Text: "i18nCommon.Between",
      Value: FilterComboboxEnumKey.Between,
      ShowInput: false,
      BetweenDate: true
    }
  ],
  listOperatorDateExpired: [
    {
      ID: 1,
      Text: "i18nCommon.UnExpired",
      Value: FilterComboboxEnumKey.UnExpired,
      ShowInput: true
    },
    {
      ID: 2,
      Text: "i18nCommon.Expired",
      Value: FilterComboboxEnumKey.Expired,
      ShowInput: true
    },
    {
      ID: 3,
      Text: "i18nCommon.Between",
      Value: FilterComboboxEnumKey.Between,
      ShowInput: false,
      BetweenDate: true
    }
  ],
  listOperatorTime: [
    {
      ID: 1,
      Text: "i18nCommon.Equal",
      Value: FilterComboboxEnumKey.Equal,
      ShowInput: true
    },
    {
      ID: 2,
      Text: "i18nCommon.Other",
      Value: FilterComboboxEnumKey.NotEqual,
      ShowInput: true
    },
    {
      ID: 3,
      Text: "i18nCommon.Smaller",
      Value: FilterComboboxEnumKey.Less,
      ShowInput: true
    },
    {
      ID: 4,
      Text: "i18nCommon.SmallerOrEqual",
      Value: FilterComboboxEnumKey.LessAndEqual,
      ShowInput: true
    },
    {
      ID: 5,
      Text: "i18nCommon.Higher",
      Value: FilterComboboxEnumKey.Greater,
      ShowInput: true
    },
    {
      ID: 6,
      Text: "i18nCommon.HigherOrEqual",
      Value: FilterComboboxEnumKey.GreaterAndEqual,
      ShowInput: true
    },
    {
      ID: 7,
      Text: "i18nCommon.Empty",
      Value: FilterComboboxEnumKey.Empty,
      ShowInput: false
    },
    {
      ID: 8,
      Text: "i18nCommon.NotEmpty",
      Value: FilterComboboxEnumKey.NotEmpty,
      ShowInput: false
    },
    {
      ID: 8,
      Text: "i18nCommon.Between",
      Value: FilterComboboxEnumKey.Between,
      ShowInput: true,
      BetweenDate: true
    }
  ],
  listOperatorMonth: [
    {
      ID: 1,
      Text: "i18nCommon.Equal",
      Value: FilterComboboxEnumKey.Equal,
      ShowInput: true
    },
    {
      ID: 2,
      Text: "i18nCommon.Other",
      Value: FilterComboboxEnumKey.NotEqual,
      ShowInput: true
    },
    {
      ID: 3,
      Text: "i18nCommon.Smaller",
      Value: FilterComboboxEnumKey.Less,
      ShowInput: true
    },
    {
      ID: 4,
      Text: "i18nCommon.SmallerOrEqual",
      Value: FilterComboboxEnumKey.LessAndEqual,
      ShowInput: true
    },
    {
      ID: 5,
      Text: "i18nCommon.Higher",
      Value: FilterComboboxEnumKey.Greater,
      ShowInput: true
    },
    {
      ID: 6,
      Text: "i18nCommon.HigherOrEqual",
      Value: FilterComboboxEnumKey.GreaterAndEqual,
      ShowInput: true
    },
    {
      ID: 7,
      Text: "i18nCommon.Empty",
      Value: FilterComboboxEnumKey.Empty,
      ShowInput: false
    },
    {
      ID: 8,
      Text: "i18nCommon.NotEmpty",
      Value: FilterComboboxEnumKey.NotEmpty,
      ShowInput: false
    },
    {
      ID: 9,
      Text: "i18nCommon.ThisMonth",
      Value: FilterComboboxEnumKey.ThisMonth,
      ShowInput: false
    },
    {
      ID: 10,
      Text: "i18nCommon.ThisYear",
      Value: FilterComboboxEnumKey.ThisYear,
      ShowInput: false
    },
    {
      ID: 11,
      Text: "i18nCommon.PreviousMonth",
      Value: FilterComboboxEnumKey.PreviousMonth,
      ShowInput: false
    },
    {
      ID: 12,
      Text: "i18nCommon.PreviousYear",
      Value: FilterComboboxEnumKey.PreviousYear,
      ShowInput: false
    },
    {
      ID: 13,
      Text: "i18nCommon.NextMonth",
      Value: FilterComboboxEnumKey.NextMonth,
      ShowInput: false
    },
    {
      ID: 14,
      Text: "i18nCommon.NextYear",
      Value: FilterComboboxEnumKey.NextYear,
      ShowInput: false
    },
    {
      ID: 15,
      Text: "i18nCommon.Between",
      Value: FilterComboboxEnumKey.Between,
      ShowInput: true,
      BetweenDate: true
    }
  ],
  listOperatorBool: [
    {
      ID: 1,
      Text: "i18nCommon.Equal",
      Value: FilterComboboxEnumKey.Equal,
      ShowInput: true
    },
    {
      ID: 2,
      Text: "i18nCommon.Other",
      Value: FilterComboboxEnumKey.NotEqual,
      ShowInput: true
    }
  ]
};
